<template>
  <div class="page-error">
    <div>404</div>
    <div>该页面不存在</div>

    <!-- <div class="page-num-list">
      <div class="page-num" @click="activeIndex != 0 ? activeIndex-- : ''">
        <img :src="prevImg" />
      </div>
      <div
        class="page-num"
        :class="index == activeIndex ? 'page-num-active' : ''"
        v-for="(item, index) in pages"
        :key="index"
        @click="activeIndex = index"
      >
        <img
          :src=ellipsisImg
          v-if="index == 2"
        />
        <span v-if="index != 2">{{ item.num }}</span>
        {{item.num}}
      </div>
      <div class="page-num">
        <img
          :src="nextImg"
          @click="activeIndex != pages.length - 1 ? activeIndex++ : ''"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      prevImg: require("../assets/images/main/prev.svg"),
      nextImg: require("../assets/images/main/next.svg"),
      ellipsisImg: require('../assets/images/main/ellipsis.svg'),
      pages: [
        {
          num: 1,
          isActive: true,
        },
        {
          num: 2,
          isActive: false,
        },
        {
          num: 3,
          isActive: false,
        },
        {
          num: 4,
          isActive: false,
        },
        {
          num: 5,
          isActive: false,
        },
      ],
      activeIndex: 0,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped lang='less'>
.page-error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #409EFF;
  font-size: 150px;

  .page-num-list {
    height: 60px;
    display: flex;
    align-items: center;

    .page-num {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #26415f;
    }

    .page-num-active {
      box-sizing: border-box;
      background: #fff;
      border: 1px solid #c9d5ef;
      border-radius: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue